export default "__VITE_ASSET__7cfcd5d9__"